import { RootState } from '../../store';
import { useAppSelector } from '../../hooks/hooksRedux';

import { StepNumber, StepperItemContainer, StepText } from './StyleGuide';
import { defaultColors, defaultBackground } from '../../styles/style-guide';

type Props = {
  text: string;
  step: number;
  active?: boolean;
  /** When provided, the step becomes clickable (e.g. to go back to validate data) */
  onClick?: () => void;
};

export function StepperItem({ text, step, active, onClick }: Props) {
  const { colors, border } = useAppSelector((state: RootState) => state.styleGuide.data);

  const primaryColor = colors.primary || defaultColors.primary;
  const secondaryColor = colors.secondary || defaultColors.secondary;
  const primaryBackgroundColor = border.secondary || defaultBackground.secondary;

  const isInactiveBgColor = '#E2E5FA';
  const isInactiveTextColor = '#FFF';

  const content = (
    <>
      <StepNumber
        $active={!!active}
        $activeColor={primaryColor}
        $inactiveBgColor={primaryBackgroundColor || isInactiveBgColor}
        $inactiveTextColor={secondaryColor || isInactiveTextColor}
      >
        {step}
      </StepNumber>
      <StepText $textColor={primaryColor}>{text}</StepText>
    </>
  );

  if (onClick) {
    return (
      <StepperItemContainer
        as="button"
        type="button"
        className="flex cursor-pointer items-center gap-2 rounded-lg border-0 bg-transparent px-0 py-0 text-left transition hover:opacity-80 focus:outline-none focus:ring-2 focus:ring-offset-1"
        onClick={onClick}
      >
        {content}
      </StepperItemContainer>
    );
  }

  return (
    <StepperItemContainer className="flex items-center gap-2">
      {content}
    </StepperItemContainer>
  );
}
